import { UIDataModel } from './report.model';

export const InteractionSummary = {
  contactTimeStamp: 'contactTimeStamp',
  summary: 'summary',
};

export const InteractionTime = {
  totalDuration: 'totalDuration',
  waitTime: 'waitTime',
  holdTime: 'holdTime',
};

export const CustomerSentiment = {
  sentimentAtStart: 'sentimentAtStart',
  sentimentAtEnd: 'sentimentAtEnd',
};

export const Interaction_Summary: Array<UIDataModel> = [
  { label: 'Date', key: 'ContactTimestamp', uiKey: InteractionSummary.contactTimeStamp },
  { label: 'Summary', key: 'Insights.Summary', uiKey: InteractionSummary.summary },
];

export const Interaction_Summary_List: Array<UIDataModel> = [
  { label: 'Customer Phone Number', key: 'ContactAttributes.CustomerEndpoint_Address', uiKey: 'phoneNumber' },
  { label: 'Dialed Number', key: 'ContactAttributes.SystemEndpoint_Address', uiKey: 'dialedNumber' },
  { label: 'Interaction Type', key: 'ContactAttributes.Channel', uiKey: 'interactionType' },
  { label: 'Contact ID', key: 'ContactId', uiKey: 'contactId' },
  // { label: 'Conversation ID', key: 'ConversationId', uiKey: 'conversationId' },
  { label: 'Resolution', key: 'Insights.CallResolution', uiKey: 'resolution' },
  { label: 'Outcome', key: 'Insights.Outcome', uiKey: 'outcome' },
];

export const Interaction_Time: Array<UIDataModel> = [
  { label: 'Total Duration', key: 'ContactAttributes.Agent_AgentInteractionDuration', uiKey: 'totalDuration' },
  { label: 'Wait Time', key: 'ContactAttributes.Queue_Duration', uiKey: 'waitTime' },
  { label: 'Hold Time', key: 'ContactAttributes.Agent_CustomerHoldDuration', uiKey: 'holdTime' },
];

export const Customer_Sentiment: Array<UIDataModel> = [
  { label: 'Sentiment at Start', key: 'Insights.CustomerSentimentAtStart', uiKey: 'sentimentAtStart' },
  { label: 'Sentiment at End', key: 'Insights.CustomerSentimentAtEnd', uiKey: 'sentimentAtEnd' },
];

export const Insights: Array<UIDataModel> = [
  { label: 'Primary Topic', key: 'Insights.PrimaryTopic', uiKey: 'primaryTopic' },
  { label: 'Topics', key: 'Insights.Topics', uiKey: 'topics' },
  { label: 'Triggers', key: 'Insights.Trigger', uiKey: 'triggers' },
  { label: 'Root Cause', key: 'Insights.RootCause', uiKey: 'rootCause' },
  { label: 'Journey Moment', key: 'Insights.JourneyMoment', uiKey: 'journeyMoment' },
  { label: 'Pain points', key: 'Insights.CustomerPainPoint', uiKey: 'painPoints' },
  { label: 'Other Channels', key: 'ContactAttributes.Channel', uiKey: 'OtherChannels' }, // Corrected if necessary
  { label: 'Support Agents', key: 'ContactAttributes.Agent_Username', uiKey: 'supportAgents' },
  { label: 'PNR', key: 'ContactAttributes.PNR', uiKey: 'pnr' },
];

export const Summary: Array<UIDataModel> = [
  { label: 'Date Range', key: 'Insights.PrimaryTopic', uiKey: 'primaryTopic' },
  { label: 'Topics', key: 'Insights.Topics', uiKey: 'topics' },
  { label: 'Triggers', key: 'Insights.Trigger', uiKey: 'triggers' },
  { label: 'Root Cause', key: 'Insights.RootCause', uiKey: 'rootCause' },
  { label: 'Journey Moment', key: 'Insights.JourneyMoment', uiKey: 'journeyMoment' },
  { label: 'Pain points', key: 'Insights.CustomerPainPoint', uiKey: 'painPoints' },
  { label: 'Other Channels', key: 'ContactAttributes.Channel', uiKey: 'OtherChannels' }, // Corrected if necessary
  { label: 'Support Agents', key: 'ContactAttributes.Agent_Username', uiKey: 'supportAgents' },
  { label: 'PNR', key: 'ContactAttributes.PNR', uiKey: 'pnr' },
];

export const SummaryArray: Array<UIDataModel> = [
  { label: 'Date range', key: 'dateRange', uiKey: 'dateRange' },
  { label: 'Aeroplan number', key: 'aeroplaneNumber', uiKey: 'aeroplaneNumber' },
  { label: 'Customer Phone Number', key: 'phoneNumber', uiKey: 'phoneNumber' },
  { label: 'Total Conversations', key: 'totalConversations', uiKey: 'totalConversations' },
  { label: 'Total Primary Topics', key: 'totalPrimaryTopics', uiKey: 'totalPrimaryTopics' },
  { label: 'Total Topics', key: 'totalTopics', uiKey: 'totalTopics' },
  { label: 'Total Root Causes', key: 'totalRootCauses', uiKey: 'totalRootCauses' },
  { label: 'List of Primary Topics', key: 'listOfPrimaryTopics', uiKey: 'listOfPrimaryTopics' },
  { label: 'List of Root Causes', key: 'listofRootCauses', uiKey: 'listofRootCauses' },
  { label: 'Interaction Time', key: 'averageInteractionTime', uiKey: 'averageInteractionTime' },
  { label: 'Queue Wait Time', key: 'averageQueueWaitTime', uiKey: 'averageQueueWaitTime' },
  { label: 'Call Hold Time', key: 'averageHoldTime', uiKey: 'averageHoldTime' },
  { label: 'Channel Pie Chart', key: 'channelDistribution', uiKey: 'channelDistribution' },
  { label: 'Resolution Pie Chart', key: 'resolutionDistribution', uiKey: 'resolutionDistribution' },
];

export const SummaryObject = {
  dateRange: 'dateRange',
  aeroplaneNumber: 'aeroplaneNumber',
  phoneNumber: 'phoneNumber',
  totalConversations: 'totalConversations',
  totalPrimaryTopics: 'totalPrimaryTopics',
  totalTopics: 'totalTopics',
  totalRootCauses: 'totalRootCauses',
  listOfPrimaryTopics: 'listOfPrimaryTopics',
  listofRootCauses: 'listofRootCauses',
  averageInteractionTime: 'averageInteractionTime',
  averageQueueWaitTime: 'averageQueueWaitTime',
  averageHoldTime: 'averageHoldTime',
  channelDistribution: 'channelDistribution',
  resolutionDistribution: 'resolutionDistribution',
};

export const Disclaimer =
  'This report is generated using RozieAI AI-driven analysis tools and is intended for informational purposes only.';

export const PoweredBy = 'Synopsis, Sentiment & Topic Analysis Services';
